import { Routes, Route } from "react-router-dom";
import RequireAuth from "../components/RequireAuth";
import NotFoundPage from "../utils/NotfoundPage";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { hasCommonValue } from "./api_params";
import { ErrorBoundary } from "react-error-boundary";
import { useLocation } from "react-router-dom";
import IwdFallback from "./IwdFallback";
import { useNavigate } from "react-router-dom";

export const IwdRoute = ({ component, section, path, auth }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const permessions = window.MENU[section];
  const userInfo = useSelector((state) => state?.userPreferenceSlice.userInfo);
  useEffect(() => {}, [component]);

  const roles = useSelector((state) => state?.userPreferenceSlice.roles);
  const groups = useSelector((state) => state?.userPreferenceSlice.groups);

  const render = () => {
    if (permessions?.groups?.length > 0) {
      if (hasCommonValue(groups, permessions?.groups)) {
        return true;
      } else {
        return false;
      }
    }
    if (permessions?.groups?.length == 0 || !permessions?.groups) {
      if (hasCommonValue(roles, permessions?.roles)) {
        return true;
      } else {
        return false;
      }
    }
  };
  useEffect(() => {
    const bearer = localStorage.getItem("user_token");
    if (!bearer) {
      navigate("/login");
    }
  }, []);
  useEffect(() => {
    if (roles?.length > 0 && groups?.length > 0) {
    }
  }, [roles, groups]);

  return (
    <>
      {section === "login" && <>{component}</>}
      {permessions?.visibility &&
        render() &&
        (auth ? (
          <RequireAuth>
            <ErrorBoundary
              resetKeys={[location.pathname]}
              FallbackComponent={IwdFallback}
            >
              {component}
            </ErrorBoundary>
          </RequireAuth>
        ) : (
          <>{component}</>
        ))}
      {userInfo !== null && (!permessions?.visibility || !render()) && (
        <NotFoundPage />
      )}
    </>
  );
};
